import React from 'react'

function Blog() {
  return (
    <div>
      
    </div>
  )
}

export default Blog
